(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('.apex-filter-trigger');
    var close = event.target.closest('[data-apex-filter-close]');
    var panel = document.getElementById('ApexCollectionFilters');
    var overlay = document.querySelector('.apex-filter-overlay');
    if (!panel || !overlay) return;
    if (trigger) {
      panel.classList.add('is-open'); overlay.classList.add('is-open'); document.body.classList.add('apex-filters-open'); trigger.setAttribute('aria-expanded', 'true');
    }
    if (close) {
      panel.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.classList.remove('apex-filters-open');
      var button = document.querySelector('.apex-filter-trigger'); if (button) button.setAttribute('aria-expanded', 'false');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
